<template>
  <div style="cursor: pointer;margin-right: 24px;" @click="toKnowledge">
    <img style="width: 24px; height: 24px;margin-right: 4px;" src="@/assets/images/question.png" alt="" srcset="">
    <span style="font-size: 14px;color:#333333;vertical-align: middle;">知识库</span>
  </div>
</template>

<script>
export default {
  methods: {
    toKnowledge() {
      this.$router.push({
        path: '/base/knowledge/show/home', // 知识库
        query: {
          // id: 'foo',
        },
      });
    },
  },
};
</script>
